import { render } from "./ProjectCard.vue?vue&type=template&id=18c7e8ea&scoped=true&ts=true"
import script from "./ProjectCard.vue?vue&type=script&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=18c7e8ea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c7e8ea"]])

export default __exports__